/** Query keys shared by the Teams and limits tabs: a change on one tab refreshes the counts on the others. */
export const TEAMS_KEY = ['onsitelive-teams', 'teams'] as const;
export const DEPARTMENT_TEAMS_KEY = ['onsitelive-teams', 'departments'] as const;
export const LIMITS_KEY = ['onsitelive-teams', 'limits'] as const;
export const RULE_KEY = ['onsitelive-teams', 'rule'] as const;
